<template>
  <div id="app">
    <Header v-show="$route.path.indexOf('ProductionInfo') == -1"></Header>
    <router-view />
    <!-- <GoTop></GoTop> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {

  },
  methods: {

  }
}
</script>

<style>
#app {
  position: relative;
}

:root {
  --mainBG: #fff;
  --activeColor: #45AFFF;
  --TextColor: #000;
  --xsMainBg: #fff;
  --xsTextColor: #4477df;
  font-family: PingFang SC, PingFang SC;
}

#swiper .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet {
  width: 80px;
  height: 5px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 0px 0px 0px 0px;
}

.swiper-pagination-bullet-active {
  background: #FFFFFF !important;
}

.swiper-pagination {
  text-align: left !important;;
  left: 189px!important;
  bottom: 88px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue